<template>
  <Alert :title="lc.message" class="mt-4" :status="lc.status">
    <template>
      <Row>
        <Col cols="12 col-sm-12">
          <span class="text-paragraph-2">{{ lc.description }}</span>
        </Col>
        <Col cols="12 col-sm-12">
          <Button
            color="primary"
            :label="lc.buttonLabel"
            @click="redirectToHireDomainRegistration"
            v-if="showButton"
          />
          <DNSModal v-if="showDNSModal"/>
        </Col>
      </Row>
    </template>
  </Alert>
</template>
<script>
import { computed } from 'vue'
import { Alert, Button, Row, Col, useLocale } from '@locaweb/design-system-vue'
import { authStore as useAuthStore } from '@/store/auth.js'
import DNSModal from './DomainStatus/DNSModal.vue'

export const SUPPORTED_STATUSES = ['domain_available', 'domain_not_configured']

export default {
  name: 'DomainStatus',
  components: {
    Alert,
    Row,
    Col,
    Button,
    DNSModal
  },
  props: {
    errorType: {
      type: String,
      validator (status) {
        return SUPPORTED_STATUSES.includes(status)
      }
    },
    address: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const lc = useLocale(`domains.addDomain.domainStatus.${props.errorType}`)
    const showButton = computed(() => props.errorType === SUPPORTED_STATUSES[0])
    const showDNSModal = computed(() => props.errorType === SUPPORTED_STATUSES[1])

    const redirectToHireDomainRegistration = () => {
      const locawebUrl = process.env.VUE_APP_LOCAWEB_URL
      const authStore = useAuthStore()
      const address = props.address
      const userName = authStore.userName

      const destinationURL = `${locawebUrl}/contratar-registro-de-dominio/?utm_campaign=FluxoRegistroCriadordeSites&utm_source=painel_criador&utm_medium=own&current_login=${userName}&domain_ids=${address}`

      return window.open(destinationURL, '_blank', 'noopener')
    }

    return {
      lc,
      redirectToHireDomainRegistration,
      showButton,
      showDNSModal
    }
  }
}
</script>
